import React, { useState, useEffect } from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'
import ListItemOption from 'ui/list_item_option'
import { Row, Col, ListGroup, Card, CardTitle, CardBody } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import parse from 'react-html-parser'
import ProductVariantCard from './product_variant_card'

const ProductVariantsModule = (props) => {
  const { config, machine, status } = props
  const { i18n } = useTranslation()
  const [current, send] = machine
  const { locale } = config
  const { product_variants, product_variant_id } = current.context

  const variantSelect = (variant) => {
    send({ type: 'PRODUCT_VARIANT_SELECTION', variant: variant })
  }

  const selectedVariant = () => {
    if (product_variants && product_variant_id) {
      return product_variants.find((variant) => variant.id == product_variant_id)
    } else {
      return null
    }
  }

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed' ? send('REOPEN_PRODUCTVARIANTSSTEP') : null
        }
      >
        <div>
          <i className="fas fa-grip-horizontal me-2" aria-hidden="true"></i>
          {status === 'completed'
            ? selectedVariant().name
            : i18n.t('product_variants_module.title')}
        </div>
      </ModuleHeader>

      <ModuleBody status={status}>
        <Row className="row-cols-1 row-cols-sm-2 row-cols-md-4 p-3 justify-content-center g-3">
          {product_variants.map((variant) => {
            const {id, name, description, featured_price_label, thumbnail} = variant
            return (
              <Col key={id} className="d-flex">
                <ProductVariantCard
                  id={id}
                  title={name}
                  description={description}
                  featured_price_label={featured_price_label}
                  thumbnail={thumbnail}
                  onSelect={() => variantSelect(variant)}
                />
              </Col>
            )
          })}
        </Row>
      </ModuleBody>

      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default ProductVariantsModule
